export const addressFr = {
    street: 'Rue',
    street2: 'Complément 1',
    street3: 'Complément 2',
    zipCode: 'Code postal',
    city: 'Ville',
    country: 'Country'
}
